import { getOTACodes } from '../../../../../../services/common'
import { LocalPersistence } from '../../../../../../factories';
import { saveOrUpdateMeetingRooms } from '../../../../../../services/meetingrooms'

const getUOMlist = async (
  setUomList : (e: []) => void
) => {
  const res = await getOTACodes('UOM', 'Area');
  let rest = res?.otacodes || []
  setUomList(rest)
}

const getAllData = async (
  form: any, props: any
) => {
  form.setFieldsValue({
      "meetingroomsid": props.generalData.meetingroomsid,
      "meetingroomslangid": props.generalData.meetingroomslangid,
      "totalcount": props.generalData.totalcount,
      "uom": props.generalData.uom,
      "smallestmeetingspace": props.generalData.smallestmeetingspace,
      "largestmeetingspace": props.generalData.largestmeetingspace,
      "totalmeetingspace": props.generalData.totalmeetingspace,
      "exhibitspace": props.generalData.exhibitspace,
      "totalexhibitspace": props.generalData.totalexhibitspace,
      "conferencespace": props.generalData.conferencespace,
      "confcoordinator": props.generalData.confcoordinator,
      "smallestroomseatingcapacity": props.generalData.smallestroomseatingcapacity,
      "largestroomseatingcapacity": props.generalData.largestroomseatingcapacity,
      "totalroomseatingcapacity": props.generalData.totalroomseatingcapacity,
      "boardroom": props.generalData.boardroom,
      "boardroomseatingcapacity": props.generalData.boardroomseatingcapacity,
      "maxcost10breakoutroom": props.generalData.maxcost10breakoutroom,
      "maxcost25breakoutroom": props.generalData.maxcost25breakoutroom,
      "conventionfacilities": props.generalData.conventionfacilities,
      "hostsocialfunctions": props.generalData.hostsocialfunctions,
      "numberofmeetingpersonnelonproperty": props.generalData.numberofmeetingpersonnelonproperty,
      "complimentaryparking": props.generalData.complimentaryparking,
      "catering": props.generalData.catering,
      "guaranteeddiscountfood": props.generalData.guaranteeddiscountfood,
      "banquetservicechargepct": props.generalData.banquetservicechargepct,
      "banquetservicechargestaxed": props.generalData.banquetservicechargestaxed,
      "actualroomforcomplimentaryroom": props.generalData.actualroomforcomplimentaryroom,
      "roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause": props.generalData.roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause
  })
}

const SaveClick = async (
  form: any, props: any, message: any
) => {
  const get_session = new LocalPersistence('session')
  const session: any = await get_session.getSessionPersistence()

  form.validateFields()
    .then(async (value: any) => {
      let boduQuery = {
          "supplier": session.supplier,
          "propertyId": session.propertyId,
          "property": {
              "meetingrooms": {
                  "meetingroomsid": props.generalData.meetingroomsid,
                  "meetingroomslangid": props.generalData.meetingroomslangid,
                  "totalcount": value.totalcount || '',
                  "uom": value.uom || '',
                  "smallestmeetingspace": value.smallestmeetingspace || '', 
                  "largestmeetingspace": value.largestmeetingspace || '',
                  "totalmeetingspace": value.totalmeetingspace || '',
                  "exhibitspace": value.exhibitspace || '',
                  "totalexhibitspace": value.totalexhibitspace || '',
                  "conferencespace": value.conferencespace || '',
                  "confcoordinator": value.confcoordinator || '',
                  "smallestroomseatingcapacity": value.smallestroomseatingcapacity || '',
                  "largestroomseatingcapacity": value.largestroomseatingcapacity || '',
                  "totalroomseatingcapacity": value.totalroomseatingcapacity || '',
                  "boardroom": value.boardroom || '',
                  "boardroomseatingcapacity": value.boardroomseatingcapacity || '',
                  "maxcost10breakoutroom": value.maxcost10breakoutroom || '',
                  "maxcost25breakoutroom": value.maxcost25breakoutroom || '',
                  "conventionfacilities": value.conventionfacilities || '',
                  "hostsocialfunctions": value.hostsocialfunctions || '',
                  "numberofmeetingpersonnelonproperty": value.numberofmeetingpersonnelonproperty || '',
                  "complimentaryparking": value.complimentaryparking || '',
                  "catering": value.catering || '',
                  "guaranteeddiscountfood": value.guaranteeddiscountfood || '',
                  "banquetservicechargepct": value.banquetservicechargepct || '',
                  "banquetservicechargestaxed": value.banquetservicechargestaxed || '',
                  "actualroomforcomplimentaryroom": value.actualroomforcomplimentaryroom || '',
                  "roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause": value.roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause || ''
              }
          }
      }
  
      saveOrUpdateMeetingRooms(boduQuery)
        .then(res => {
          if (res.result.success) {
              props.setGeneralData({
                  ...props.generalData,
                  ...{
                    "meetingroomsid": props.generalData.meetingroomsid,
                    "meetingroomslangid": props.generalData.meetingroomslangid,
                    "totalcount": value.totalcount || '',
                    "uom": value.uom || '',
                    "smallestmeetingspace": value.smallestmeetingspace || '', 
                    "largestmeetingspace": value.largestmeetingspace || '',
                    "totalmeetingspace": value.totalmeetingspace || '',
                    "exhibitspace": value.exhibitspace || '',
                    "totalexhibitspace": value.totalexhibitspace || '',
                    "conferencespace": value.conferencespace || '',
                    "confcoordinator": value.confcoordinator || '',
                    "smallestroomseatingcapacity": value.smallestroomseatingcapacity || '',
                    "largestroomseatingcapacity": value.largestroomseatingcapacity || '',
                    "totalroomseatingcapacity": value.totalroomseatingcapacity || '',
                    "boardroom": value.boardroom || '',
                    "boardroomseatingcapacity": value.boardroomseatingcapacity || '',
                    "maxcost10breakoutroom": value.maxcost10breakoutroom || '',
                    "maxcost25breakoutroom": value.maxcost25breakoutroom || '',
                    "conventionfacilities": value.conventionfacilities || '',
                    "hostsocialfunctions": value.hostsocialfunctions || '',
                    "numberofmeetingpersonnelonproperty": value.numberofmeetingpersonnelonproperty || '',
                    "complimentaryparking": value.complimentaryparking || '',
                    "catering": value.catering || '',
                    "guaranteeddiscountfood": value.guaranteeddiscountfood || '',
                    "banquetservicechargepct": value.banquetservicechargepct || '',
                    "banquetservicechargestaxed": value.banquetservicechargestaxed || '',
                    "actualroomforcomplimentaryroom": value.actualroomforcomplimentaryroom || '',
                    "roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause": value.roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause || ''
                  }
              })
              props.setEditFlag(false)
              window.cancelEdition()
              props.setOneNavDisabled(false)
          } else {
              message.error({
                  content: res?.error[0]?.message || 'operation failed'
              });
          }
      }, err => {
          message.error({
              content: err?.message || err?.error[0]?.message
          });
      })
  }).catch(() => {
      message.error({
          content: 'Check all the fields please.',
      });
  })
}

const validateFieldsError = (
  changedValues: any, allValues: any,
  form: any, setDisabledStatus: any
) => {
  form.validateFields()
  .then(() => {
      setDisabledStatus(false)
  }).catch(() => {
      let savelock = false
      let s = form?.getFieldsError()
      for (let i = 0; i < s.length; i++) {
          if (s[i].errors.length) {
              savelock = true;
              break
          }
      }
      setDisabledStatus(savelock)
  })
}

export {
  getUOMlist,
  getAllData,
  SaveClick,
  validateFieldsError
}
